import Vue from "vue";
// import createAuth0Client from "@auth0/auth0-spa-js";
import axios from 'axios';
import * as msal from "@azure/msal-browser";

import {msalConfigDefault, loginRequestDefault, tokenRequestDefault} from "./authConfig";
import login from "../router/views/account/login";

const DEFAULT_REDIRECT_CALLBACK = () =>
    window.history.replaceState({}, document.title, window.location.pathname);

let instance;

export const getInstance = () => instance;

export const useActiveDirectory = (router, {
                                       msalConfig = msalConfigDefault,
                                       loginRequest = loginRequestDefault,
                                       tokenRequest = tokenRequestDefault,
                                       ...options
                                   }) => {
    if (instance) return instance;

    instance = new Vue({
        data() {
            return {
                loading: true,
                isAuthenticated: false,
                user: {},
                msalInstance: null,
                popupOpen: false,
                error: null,
                serverUser: null
            };
        },
        methods: {
            selectAccount() {
                const currentAccounts = this.msalInstance.getAllAccounts();
                if (currentAccounts === null) {
                    return;
                } else if (currentAccounts.length > 1) {
                    // Add choose account code here
                    alert('multiple accounts selected');
                    console.warn("Multiple accounts detected.");
                } else if (currentAccounts.length === 1) {
                    this.user = currentAccounts[0];
                    this.isAuthenticated = true;
                    this.loading = false
                }
            },

            loginWithPopup() {
                this.popupOpen = true;
                this.isAuthenticated = false;
                this.loading = true;

                if (window.location.pathname !== '/') {
                    localStorage.setItem('desiredPath', window.location.pathname);
                    window.location.href = window.location.origin;
                    return;
                }

                this.msalInstance.loginPopup(loginRequest).then(r => {
                    if (r !== null) {
                        this.user = r.account;
                        // console.log(this.user);

                       // Now get user
                       axios.get(API_BASE + '/user').then(r => {
                           this.serverUser = r.data;
                           console.log('Server User:');
                           console.log(this.serverUser);
                           this.popupOpen = false;
                           this.isAuthenticated = true;
                           this.loading = false;
                           this.error = null;

                           let desiredPath = localStorage.getItem('desiredPath');
                           if (desiredPath) {
                               router.push(desiredPath);
                               localStorage.removeItem('desiredPath');
                           }
                       }).catch(e => {
                           this.serverUser = null;
                           this.popupOpen = false;
                           this.isAuthenticated = true;
                           this.loading = false;
                           this.error = null;
                       });
                    } else {
                        this.error = null;
                        this.popupOpen = false;
                        this.isAuthenticated = false;
                        this.selectAccount();
                    }
                }).catch(e => {
                    this.error = e;
                    console.log(e);
                    this.popupOpen = false;
                    this.isAuthenticated = false;
                });
            },

            async getTokenPopup() {
                let request = tokenRequest;
                request.account = this.msalInstance.getAccountByUsername(this.user.username);
                const tokenResponse = await this.msalInstance.acquireTokenSilent(request).catch(error => {
                    this.error = error;
                    console.warn("silent token acquisition fails. acquiring token using redirect");
                    if (error instanceof msal.InteractionRequiredAuthError) {
                        // fallback to interaction when silent call fails
                        return this.msalInstance.acquireTokenPopup(request).then(tokenResponse => {
                            return tokenResponse;
                        }).catch(error => {
                            console.error(error);
                        });
                    } else {
                        console.warn(error);
                    }
                });
                // console.log('Token:')
                // console.log(tokenResponse);
                return tokenResponse.accessToken;
            },

            async logout() {
                const currentAccount = this.msalInstance.getAccountByUsername(this.user.username);
                await this.msalInstance.logoutRedirect({
                    account: currentAccount,
                    // postLogoutRedirectUri: ""
                });
                // return this.auth0Client.logout(o);
            }
        },
        async created() {
            // this.auth0Client = await createAuth0Client({
            //     ...options,
            //     client_id: options.clientId,
            //     redirect_uri: redirectUri
            // });

            this.msalInstance = new msal.PublicClientApplication(msalConfig);
            this.loginWithPopup();

            // try {
            //     if (
            //         window.location.search.includes("code=") &&
            //         window.location.search.includes("state=")
            //     ) {
            //         const {appState} = await this.auth0Client.handleRedirectCallback();
            //         this.error = null;
            //         onRedirectCallback(appState);
            //     }
            // } catch (e) {
            //     this.error = e;
            // } finally {
            //     this.isAuthenticated = await this.auth0Client.isAuthenticated();
            //     this.user = await this.auth0Client.getUser();
            //     this.loading = false;
            // }
        }
    });

    return instance;
};

export const ActiveDirectoryPlugin = {
    install(Vue, router, options) {
        Vue.prototype.$auth = useActiveDirectory(router, options);
    }
};